// Module
var code = `<marketplace-item class="self-start" contact="template" plan-select="\$ctrl.planSelect" plan-account="\$ctrl.planAccount" ng-repeat="template in \$ctrl.templates track by \$index" size="{{\$ctrl.size}}"> </marketplace-item> `;
// Exports
module.exports = code;